import React from "react";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-4 text-center mt-auto">
      <p className="text-sm">&copy; {new Date().getFullYear()} LawyerConnect. All rights reserved.</p>
    </footer>
  );
}